

import React from 'react';
import {useTranslation} from "react-i18next";
import Helmet from "react-helmet";

function HelmetTagsComponent(props) {

    const { t, i18n } = useTranslation()

    // TODO: add meta tags
    // https://medium.com/@vinesheg/beginners-guide-meta-tags-217e6e0dfda6

    return (<>
        <Helmet>
            <meta http-equiv="refresh" content="30" />

            <link rel={'canonical'} href={'https://y-l.pro/' + props.canonical} />

            <meta name="author" content={props.author} />
            <meta name="description" content={props.description} />
            <meta name="keywords" content={props.keywords}/>

            <meta property={'og:url'} content={props.url}/>
            <meta property={'og:title'} content={props.title ?? 'TITLE'}/>
            <meta property={'og:description'} content={props.description}/>
            <meta property={'og:type'} content={'website'}/>
            <meta property={'og:image'} content={props.image} />

            {
                props.tags &&  props.tags.map((tag, i) => <meta property={'article:tag'} content={props.tag}/>)
            }

            <title>
                {props.title ?? 'TITLE'}
            </title>

        </Helmet>
    </>);
}

export default HelmetTagsComponent;
